module.exports = __webpack_public_path__ + "img/材料力学5_12_5.f5dc75b0.jpg";